<template>
  <!-- 固定组件在头部 -->
   
  <NavigationBar />
  
  <div class="app">
    <KeepAlive><router-view @scroll-to-contact="(type) => handleScrollToContact(type)" @showlink="(showtorf)=>showlinkUs(showtorf)"></router-view></KeepAlive>
  </div>
  <LinkUs ref="contactRef" v-if="showLinkUs"/>
  <HangBox v-if="!isMobile && showLinkUs"/>
  <FooterBar />
</template>

<script setup name="App">
import NavigationBar from '@/components/NavigationBar'
import FooterBar from '@/components/FooterBar.vue';
import LinkUs from './components/LinkUs.vue';
import HangBox from './components/HangBox.vue';
import { ref } from 'vue'
import { onMounted ,onUnmounted} from 'vue'
onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
})
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})
const contactRef = ref(null)
let showLinkUs = ref(true)
const isMobile = ref(false)
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 1024
}
function handleScrollToContact(type) {
  contactRef.value?.scrollToMe();
  contactRef.value?.setResourceType(type);
}
function showlinkUs(showtorf) {
  showLinkUs.value = showtorf
  console.log(showLinkUs.value);
}
</script>
<style lang="scss" scoped></style>
<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.app {
  margin: 0 auto;
  margin-top: 5em;
}
</style>
